export const PAIRING_IN_PROGRESS_LOADER = 'PAIRING_IN_PROGRESS_LOADER';
export const TNC_PAGE_LOADER = 'TNC_PAGE_LOADER';
export const SCP_CHECK_LOADER = 'SCP_CHECK_LOADER';
export const LOADER_RESET = 'LOADER_RESET';
